import React from 'react'

const Nodejs_Coding_Pratice_2 = () => {
  return (
    <div>
      <h1>Coding Pratice 2</h1>
    </div>
  )
}

export default Nodejs_Coding_Pratice_2
